module.exports = __webpack_public_path__ + "static/fonts/PingFangSC_SemiBold.e9ad33e0.otf";